<template>
	<b-row lg="12" class="mt-2">
		
		<!-- Has the client had any hospital stays since your last visit? -->
		<b-col :lg="cols? cols : 6">
			<b-form-group label="Has the client had any hospital stays since your last visit?" label-class="h5">
				<b-form-radio-group
					v-model="hospitalStay"
					id="hospitalStay"
					name="hospitalStay"
					@change="validateFromDate"
					required
				>
					<b-form-radio value="1">Yes</b-form-radio>
					<b-form-radio value="0">No</b-form-radio>
				</b-form-radio-group>
			</b-form-group>
		</b-col>
		
		<!-- Is the client still currently in the hospital? -->
		<b-col :lg="cols? cols : 6" v-if="hospital_stays_enhanced_flow && hospitalStay == 1">
			<b-form-group label="Is the client still currently in the hospital?" label-class="h5">
				<b-form-radio-group
					v-model="stillInHospital"
					id="stillInHospital"
					name="stillInHospital"
					@change="validateFromDate"
					:required="hospital_stays_enhanced_flow"
				>
					<b-form-radio value="1">Yes</b-form-radio>
					<b-form-radio value="0">No</b-form-radio>
				</b-form-radio-group>
			</b-form-group>
		</b-col>

		<!-- Hospital Stay - From and To Date -->
		<b-col :lg="cols? cols : 6" v-if="hospital_stays_enhanced_flow && hospitalStay == 1">
			<b-form-group label="Hospital Stay Dates" label-for="fromDate">
				<div class="from-to-dates-grid">

					<!-- From label for small devices -->
					<div class="pb-1">
						&nbsp;from&nbsp;
					</div>

					<!-- From date selector with error / info message -->
					<div>
						<date-picker
							v-model="fromDate"
							placeholder="Date (MM/DD/YYYY)"
							@input="validateFromDate"
							:required="hospital_stays_enhanced_flow && hospitalStay == 1"
						></date-picker>

						<div>
							<small class="form-text pl-2">
								<div class="icon-message" :class="fromMeta.class">
									<i
										class="fa"
										:class="fromMeta.valid ? 'fa-check-circle' : 'fa-info-circle'"
									></i>
									<span class="pl-2">
										{{ fromMeta.message? fromMeta.message : 'From date is required.' }}
									</span>
								</div>
							</small>
						</div>
					</div>

					<!-- To label for small devices -->
					<div class="py-1">
						&nbsp;to&nbsp;
					</div>

					<!-- To Date selector with error / info message -->
					<div>
						<date-picker
							v-model="toDate"
							placeholder="Date (MM/DD/YYYY)"
							@input="validateToDate"
							:required="hospital_stays_enhanced_flow && stillInHospital == 0"
							:disabled="stillInHospital == 1"
						></date-picker>
						<div>
							<small v-if="stillInHospital == 0" class="form-text pl-2">
								
								<div class="icon-message" :class="toMeta.class">
									<i
										class="fa"
										:class="toMeta.valid ? 'fa-check-circle' : 'fa-info-circle'"
									></i>
									<span class="pl-2">
										{{ toMeta.message? toMeta.message : 'To Date is required.' }}
									</span>
								</div>
							</small>
							<small v-if="stillInHospital == 1" class="form-text text-info pl-2">
								<i class="fa fa-info-circle"></i> &nbsp; Not Applicable.
							</small>
						</div>
					</div>
				</div>
			</b-form-group>
		</b-col>
	</b-row>
</template>

<script>
	import FormatsDates from "../mixins/FormatsDates";

	export default {

		mixins: [ FormatsDates ],

		props: {
			cols : {
				type	 : Number,
				required : false
			},
			max : {
				type	 : String,
				required : false
			},
			hospital_stay : {
				type	 : Boolean,
				required : false,
				default  : false,
			},
			hospital_stays_enhanced_flow : {
				type	 : Boolean,
				required : false,
				default  : false,
			},
			still_in_hospital : {
				type	 : Boolean,
				required : false,
				default  : false,
			},
			from_date : {
				type	 : String,
				required : false,
				default  : '',
			},
			to_date : {
				type	 : String,
				required : false,
				default  : '',
			},
		},
		data() {
			return {
				hospitalStay	: 0,

				stillInHospital	: 0,

				maxDate		: '',

				fromDate	: '',
				toDate		: '',

				fromMeta	: {},
				toMeta		: {},
			}
		},
		created(){},
		mounted() {
			this.hospitalStay		= this.hospital_stay ? 1 : 0;
			this.stillInHospital	= this.still_in_hospital ? 1 : 0;				

			if (this.hospitalStay == 0)
				return;

			if (this.from_date)
				this.fromDate = this.convertDateYmdToMdy(this.from_date);

			if (this.stillInHospital == 0 && this.to_date)
				this.toDate = this.convertDateYmdToMdy(this.to_date);

			this.updateMaxDate();
		},
		computed: {},
		methods: {
			updateMaxDate() {
				
				this.maxDate = this.max ?
									this.max :
									this.convertDateYmdToMdy((new Date).toISOString());
				
				this.validateFromDate();
			},
			emit () {
				let fromDate = null, toDate = null, stillInHospital = 0;

				if ((this.hospitalStay == 1) && this.hospital_stays_enhanced_flow) {

					stillInHospital = this.stillInHospital;

					if (this.fromDate)
						fromDate = this.formatDateMDYtoYMD(this.fromDate);
					
					if ((this.stillInHospital == 0) && this.toDate)
						toDate = this.formatDateMDYtoYMD(this.toDate);

				}

				this.$emit('hospital-stay-updated', {
					hospitalStay: this.hospitalStay,
					stillInHospital,

					fromDate,
					toDate
				});
			},
			resetHospitalStayFields() {
				this.stillInHospital = 0;
				this.fromDate = '';
				this.toDate = '';
				this.fromMeta = {};
				this.toMeta = {};
			},
			validateFromDate () {
				
				this.fromMeta =	this.checkIfDateInRange(
									'From',
									this.fromDate,
									['', this.maxDate]
								);

				if (this.fromMeta.valid) {
					this.updateToDateWithoutErrors();
					return;
				}

				setTimeout(() => {
					this.fromDate = this.fromMeta.replaceWith;
					this.updateToDateWithoutErrors();
				}, 0);
			},
			updateToDateWithoutErrors() {
				if (this.stillInHospital == 0) {
					this.validateToDate(false);
					return;
				}

				this.toDate = '';
				this.toMeta = {};

				this.emit();
			},
			validateToDate(ui = true) {
				this.toMeta =	this.checkIfDateInRange(
									'To',
									this.toDate,
									[ this.fromDate, '']
								);
				
				if (this.toMeta.valid) {
					this.emit();
					return;
				}

				setTimeout(() => {
					
					this.toDate = this.toMeta.replaceWith;

					if (!ui) {
						this.toMeta = this.checkIfDateInRange('', this.toDate);
					}

					this.emit();
				}, 0);
			}
		},
		watch: {
			max() {
				this.updateMaxDate();
			},
			hospitalStay(val) {
				this.hospitalStay = val;

				if (val == 0)
					this.resetHospitalStayFields();

				this.emit();
			},
			stillInHospital(val) {
				this.stillInHospital = val;

				if (val == 1) {
					this.toDate = "";
					this.toMeta = {};
				}

				this.emit();
			},
		},
	}
</script>

<style>
	.from-to-dates-grid {
		display: grid;
		grid-template-columns: 1fr auto 1fr;
	}
	.from-to-dates-grid > div:nth-child(1) {
		display: none;
	}
	.icon-message {
		display: flex;
		align-items: center;
	}
	@media only screen and (max-width: 475px){
		.from-to-dates-grid {
			grid-template-columns: 1fr;
		}
		.from-to-dates-grid > div:nth-child(1), .from-to-dates-grid > div:nth-child(3) {
			display: block;
			text-transform: capitalize;
		}
	}
</style>
